const formFields = [
    { field: 'serialNumber', selector: 'input[name="serialNumber"]' },
    { field: 'verificationCode', selector: 'input[name="verificationCode"]' },
    { field: 'serialNumber_confirmation', selector: 'input[name="serialNumber_confirmation"]' },
    { field: 'registrationPlate', selector: 'input[name="registrationPlate"]' },
    { field: 'subscriptions', selector: 'input[name="subscriptions"]' },
];

const sentFormFields=[
    { field: 'serialNumber', selector: 'input[name="serialNumber"]' },
    { field: 'serialNumber_confirmation', selector: 'input[name="serialNumber_confirmation"]' },
    { field: 'verificationCode', selector: 'input[name="verificationCode"]' },
    { field: 'registrationPlate', selector: 'input[name="registrationPlate"]' },
]

const lostTagFormFields = [
    { field: 'lost_tag_reason', selector: 'textarea[name="lost_tag_reason"]' },
];

const mlffFormFields = [
    { field: 'serialNumber', selector: 'input[name="serialNumber"]' },
    { field: 'serialNumber_confirmation', selector: 'input[name="serialNumber_confirmation"]' },
    { field: 'verificationCode', selector: 'input[name="verificationCode"]' },
];

const mlffSentFormFields = [
    { field: 'serialNumber', selector: 'input[name="serialNumber"]' },
    { field: 'serialNumber_confirmation', selector: 'input[name="serialNumber_confirmation"]' },
    { field: 'verificationCode', selector: 'input[name="verificationCode"]' },
];

export { formFields, sentFormFields, lostTagFormFields, mlffFormFields, mlffSentFormFields };
